module.exports = __webpack_public_path__ + "img/plug.a6841251.svg";